var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"title":_vm.title}}),_c('MonsterDescription',_vm._b({attrs:{"isAtDetail":""}},'MonsterDescription',{ monster: _vm.monster },false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }